module.exports = __webpack_public_path__ + "img/abundant1.b0e8fd92.png";